var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReader20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m23 16.718-5.525-1.512L23 13.693l-.614-2.282-5.498 1.505 4.042-4.13-1.668-1.662-4.003 4.09 1.47-5.609L14.465 5 13 10.583 11.537 5l-2.266.605 1.47 5.61-4.003-4.09-1.666 1.66 4.04 4.13-5.498-1.504L3 13.693l5.526 1.513L3 16.718 3.614 19l5.837-1.61a3.245 3.245 0 0 0 2.382-3.129h2.334c0 1.46.975 2.74 2.382 3.129L22.386 19z",
  clipRule: "evenodd"
})));
export default SvgReader20;